import { useContext, useSyncExternalStore } from "react";
import { AudioContext } from "@/context/audio";

/**
 * Where playback is, in whole seconds, and how long the episode is. Read from the player when it reports a change,
 * so there is no timer of our own. A component re-renders only when a whole second has passed (or the length
 * becomes known), not on each of the player's updates, which come several times a second.
 */
export const usePlaybackProgress = () => {
    const sound = useContext(AudioContext);
    const time = useSyncExternalStore(sound.subscribe, () => Math.floor(sound.seek()));
    const duration = useSyncExternalStore(sound.subscribe, () => Math.floor(sound.duration()));
    return { time, duration };
};
